import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import useTestMutation from "../../api/mutations/testMutation";
import { CustomButton } from "../../components/CustomButton";
import { toast } from "react-toastify";
import GoogleTag from "../../components/GoogleTag";

const SUCCESS_TITLE = "Betalningen lyckades!";
const START_TEST_BUTTON_TEXT = "Starta testet";
const ERROR = "Misslyckades med att starta testet";

const PaymentCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const { startTest } = useTestMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Facebook Pixel Purchase Event
    if (
      typeof window !== "undefined" &&
      typeof (window as any).fbq === "function"
    ) {
      // console.log("Firing FB Pixel Purchase event");
      (window as any).fbq("track", "Purchase", {
        value: 249,
        currency: "SEK",
      });
    } else {
      console.warn("Facebook Pixel is not loaded.");
    }
  }, []);

  const handleStartTestClick = async () => {
    const isn = localStorage.getItem("isn");
    if (!isn) {
      const errorMessage =
        "Det uppstod ett fel, det går inte att starta testet";
      toast.error(errorMessage, {
        style: {
          backgroundColor: "#3F51B5",
        },
      });
      return;
    }

    const sessionId = uuidv4();
    const dateTime = new Date().toISOString();
    setIsSubmitting(true);
    // Trigger the startTest mutation
    startTest
    .trigger({ isn, sessionId, dateTime })
    .then(() => {
      localStorage.setItem("sessionId", sessionId);
      navigate("/test");
    })
    .catch((error: any) => {
      const errorCode =
        error?.response?.data?.error?.code ||
        error?.data?.error?.code ||
        error?.error?.code ||
        error?.code;

      if (
        errorCode === "TestFlowAlreadyStarted" ||
        error?.message?.includes("Test flow already started")
      ) {
        navigate("/test");
        return;
      }

      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.data?.error?.message ||
        error?.message ||
        ERROR;

      toast.error(errorMessage, {
        style: { backgroundColor: "#3F51B5" },
      });
    })
    .finally(() => {
      setIsSubmitting(false);
    });
  };

  return (
    <main className="flex-grow h-full flex items-center justify-center">
      <GoogleTag />
      <div className="flex flex-col justify-center items-center w-full">
        <div className="max-w-[600px] flex flex-col gap-8 w-full h-full justify-center items-center p-9 bg-primary-card rounded-lg">
          <h1 className="text-white text-4xl font-nunito">{SUCCESS_TITLE}</h1>
          <h5 className="text-white text-xl font-nunito leading-snug text-center">
            Du kan nu påbörja testet.
          </h5>
          <CustomButton
            customStyles="h-[56px] w-full sm:max-w-[330px]"
            onClick={handleStartTestClick}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Laddar..." : START_TEST_BUTTON_TEXT}
          </CustomButton>
        </div>
      </div>
    </main>
  );
};

export default PaymentCompletePage;
